module.exports = __webpack_public_path__ + "static/media/Data_APLICACOES_EJOGOS-09.f1433948.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/AplJogos/Data_APLICACOES_EJOGOS-09.png
// module id = 11
// module chunks = 0